import { CloseIcon } from "components/ui/icons/uploadbar/CloseIcon"
import { FurnitureStatusIcon } from "components/ui/customWebviewer/ElevationReferencesSidebar/icons/FurnitureStatusIcon"
import { BackButton } from "components/ui/customWebviewer/shared/BackButton/BackButton"
import { SidebarOptionsMenu } from "components/ui/customWebviewer/shared/SidebarOptionsMenu/SidebarOptionsMenu"
import type { TFurnitureStatus } from "types/elevationReferences.type"
import style from "./FurnitureHeader.module.scss"

const { header, headerLeft, headerIcon, headerTitle, headerActions, closeButton } = style

type Props = {
	title: string
	status?: TFurnitureStatus
	onClose?: () => void
	onBack?: () => void
	/** REQ-296: raises the shared delete confirmation for this object. Omit to hide the ⋯ menu. */
	onDelete?: () => void
	/**
	 * Off in the batch panel (REQ-403), whose title names a COUNT rather than an object — a status
	 * diamond there would claim a single state for a selection that may hold several.
	 */
	showStatusIcon?: boolean
}

export const FurnitureHeader = ({ title, status, onClose, onBack, onDelete, showStatusIcon = true }: Props) => {
	return (
		<div className={header} data-hotkey-skip>
			<div className={headerLeft}>
				{onBack && (
					<BackButton
						onClick={onBack}
						ariaLabel="Jump to connected elevation reference"
						testId="furniture-back-to-eref"
					/>
				)}
				{showStatusIcon ? (
					<span className={headerIcon}>
						<FurnitureStatusIcon status={status} />
					</span>
				) : null}
				<span className={headerTitle}>{title}</span>
			</div>
			<div className={headerActions}>
				{onDelete && <SidebarOptionsMenu onDelete={onDelete} ariaLabel="Object actions" />}
				<button className={closeButton} onClick={onClose} aria-label="Close sidebar">
					<CloseIcon />
				</button>
			</div>
		</div>
	)
}
